/**
 * Naming convention: --[category]-[role]-[property/state]
 * Ex. --[bg|color|border|text]-[brand|accent|danger|surface]-[hover|focus|active|disabled]
 */
export const cssVariableNames = {
  colorBrand: '--color-brand',
  colorAccent: '--color-accent',
  textBrand: '--text-brand',
  textAccent: '--text-accent',
  bgBrandHover: '--bg-brand-hover',
  bgAccentHover: '--bg-accent-hover',
  bgBrandActive: '--bg-brand-active',
  bgDisabled: '--bg-disabled',
  textDisabled: '--text-disabled',
  textAccentDisabled: '--text-accent-disabled',
  bgAccentDisabled: '--bg-accent-disabled',
  bgAccentActive: '--bg-accent-active',
  colorBrandActive: '--color-brand-active',
  bgAccentRelaxed: '--bg-accent-relaxed',
  bgAccentRelaxedHover: '--bg-accent-relaxed-hover',
  bgAccentRelaxedActive: '--bg-accent-relaxed-active',
  colorBrandFocus: '--color-brand-focus',
  colorBrandHover: '--color-brand-hover',
  colorAccentHover: '--color-accent-hover',
  colorAccentActive: '--color-accent-active',
  borderSeparator: '--border-separator',
  outlineFocus: '--outline-focus',
  outlineColor: '--outline-color',
  borderBrandFocus: '--border-brand-focus',
  borderColor: '--border-color',
} as const;

export const cssVariables = {
  colorBrand: `var(${cssVariableNames.colorBrand})`,
  colorAccent: `var(${cssVariableNames.colorAccent})`,
  textBrand: `var(${cssVariableNames.textBrand})`,
  textAccent: `var(${cssVariableNames.textAccent})`,
  bgBrandHover: `var(${cssVariableNames.bgBrandHover})`,
  bgAccentHover: `var(${cssVariableNames.bgAccentHover})`,
  bgBrandActive: `var(${cssVariableNames.bgBrandActive})`,
  bgDisabled: `var(${cssVariableNames.bgDisabled})`,
  textDisabled: `var(${cssVariableNames.textDisabled})`,
  textAccentDisabled: `var(${cssVariableNames.textAccentDisabled})`,
  bgAccentActive: `var(${cssVariableNames.bgAccentActive})`,
  bgAccentDisabled: `var(${cssVariableNames.bgAccentDisabled})`,
  bgAccentRelaxed: `var(${cssVariableNames.bgAccentRelaxed})`,
  bgAccentRelaxedHover: `var(${cssVariableNames.bgAccentRelaxedHover})`,
  bgAccentRelaxedActive: `var(${cssVariableNames.bgAccentRelaxedActive})`,
  colorBrandActive: `var(${cssVariableNames.colorBrandActive})`,
  colorBrandFocus: `var(${cssVariableNames.colorBrandFocus})`,
  colorBrandHover: `var(${cssVariableNames.colorBrandHover})`,
  colorAccentHover: `var(${cssVariableNames.colorAccentHover})`,
  colorAccentActive: `var(${cssVariableNames.colorAccentActive})`,
  outlineFocus: `var(${cssVariableNames.outlineFocus})`,
  outlineColor: `var(${cssVariableNames.outlineColor})`,
  borderSeparator: `var(${cssVariableNames.borderSeparator})`,
  borderBrandFocus: `var(${cssVariableNames.borderBrandFocus})`,
  borderColor: `var(${cssVariableNames.borderColor})`,
} as const;

export type CssVariablesType = typeof cssVariables;
